import CircularProgress from '@mui/material/CircularProgress';
import MuiIconButton, { type IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { forwardRef } from 'react';

import { calculateIconSize } from '../Button/calculateIconSize';

type IconButtonOptions = {
  loading?: boolean;
};

export type IconButtonProps<C extends React.ElementType> = MuiIconButtonProps<
  C,
  {
    component?: C;
  }
> &
  IconButtonOptions;

const Component = <C extends React.ElementType = 'button'>(
  props: IconButtonProps<C>,
  ref: React.ForwardedRef<HTMLButtonElement>
) => {
  const { children, disabled, loading, size, ...rest } = props;

  return (
    <MuiIconButton {...rest} ref={ref} aria-busy={loading || undefined} disabled={disabled || loading} size={size}>
      {loading ? <CircularProgress size={calculateIconSize(size)} /> : children}
    </MuiIconButton>
  );
};

export const IconButton = forwardRef(Component) as <C extends React.ElementType = 'button'>(
  props: IconButtonProps<C>
) => React.ReactElement;
